document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.bss-cols');

  function getYouTubeId(input) {
    if (!input) return '';

    if (!input.includes('/') && !input.includes('youtube')) {
      return input;
    }

    const patterns = [
      /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?\/]+)/,
      /youtube\.com\/shorts\/([^&?\/]+)/
    ];

    for (const pattern of patterns) {
      const match = input.match(pattern);
      if (match) return match[1];
    }

    return input;
  }

  sections.forEach(function (section) {
    const modal = section.querySelector('.bss-video-modal');
    const iframe = section.querySelector('.bss-video-wrapper iframe');
    const closeBtn = section.querySelector('.bss-modal-close');
    const overlay = section.querySelector('.bss-modal-overlay');
    const triggers = section.querySelectorAll('.bss-video-trigger');

    if (!modal || !iframe || !closeBtn || !overlay || !triggers.length) return;

    function closeModal() {
      modal.classList.remove('active');
      iframe.src = '';
      document.body.style.overflow = '';
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        const videoIdDesktop = getYouTubeId(this.getAttribute('data-video-id-desktop'));
        const videoIdMobile = getYouTubeId(this.getAttribute('data-video-id-mobile'));

        const isMobile = window.innerWidth <= 749;
        const videoId = isMobile && videoIdMobile ? videoIdMobile : videoIdDesktop;

        if (!videoId) return;

        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&rel=0&enablejsapi=1&modestbranding=1&showinfo=0&controls=0`;
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    closeBtn.addEventListener('click', closeModal);
    overlay.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
  });
});